import React from "react";

const ITEMS = [
  {
    label: "No Fee Unless We Win",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 12l2 2 4-4" />
        <circle cx="12" cy="12" r="10" />
      </svg>
    ),
  },
  {
    label: "Available 24/7",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    ),
  },
  {
    label: "Millions Recovered",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 3v18M17 6H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </svg>
    ),
  },
];

export default function TrustBar() {
  return (
    <section
      data-testid="trust-bar"
      className="relative bg-[#06122A] border-y border-[#B89968]/20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-[#B89968]/15">
          {ITEMS.map((it) => (
            <div
              key={it.label}
              className="flex items-center justify-center gap-4 py-6 md:py-7 px-4 text-center md:text-left"
            >
              <span className="text-[#B89968] shrink-0">{it.icon}</span>
              <span className="font-serif-display text-white text-lg md:text-xl tracking-wide">
                {it.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
